import {loading, stopLoading} from "../../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {initTomSelectInput} from "../../../helpers/inputs/tom-select/tom-select";

function initProductionAuditionChooseAuditionIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	// Setup audition day select
	const auditionDaySelect = document.querySelector('select[name="audition_day"]');
	auditionDaySelect.addEventListener('change', handleAuditionDayChange)
	initTomSelectInput(auditionDaySelect);

	// Setup audition selects
	document.querySelectorAll('.audition-date-select').forEach(dateSelect => {
		initTomSelectInput(dateSelect);
	})

	// Setup virtual audition toggle
	/** @var {HTMLElement} */
	const auditionDateContainer = document.querySelector('.audition-date-container');
	/** @var {HTMLElement} */
	const virtualAuditionContainer = document.querySelector('.virtual-audition-container');

	/** @var {HTMLInputElement} */
	const virtualAuditionCheckbox = document.querySelector('input[name="is_virtual_audition"]');
	virtualAuditionCheckbox.addEventListener('change', handleVirtualAuditionToggle);

	/** @var {HTMLInputElement} */
	const virtualAuditionLink = document.querySelector('input[name="virtual_audition_link"]');

	// Initial render
	handleVirtualAuditionToggle();
	handleAuditionDayChange();

	/** Methods */

	function handleContinueRequest() {
		loading();

		// Retrieve audition date id from active container
		const auditionSelect = document.querySelector('.timeslot-container:not(.d-none) .audition-date-select');
		const auditionId = auditionSelect ? auditionSelect.value : undefined;

		const data = {
			audition_id: auditionId,
			is_virtual_audition: virtualAuditionCheckbox.checked,
			virtual_audition_link: virtualAuditionLink ? virtualAuditionLink.value : null,
		};

		Axios.post(submitButton.dataset.route, data)
			.then(response => {
				setTimeout(() => {
					// Show loading again
					loading();

					// Redirect to next step
					// noinspection JSUnresolvedReference
					window.location.href = response.data.redirectUrl;
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)

	}

	function handleVirtualAuditionToggle() {
		if (virtualAuditionCheckbox.checked) {
			virtualAuditionContainer.classList.remove('d-none');
			auditionDateContainer.classList.add('d-none');
		} else {
			virtualAuditionContainer.classList.add('d-none');
			auditionDateContainer.classList.remove('d-none');
		}
	}

	function handleAuditionDayChange() {
		const selectedDay = auditionDaySelect.value;

		if (!selectedDay) {
			// No available auditions
			return;
		}

		document.querySelectorAll('.timeslot-container').forEach(container => {
			if (container.dataset.auditionDay === selectedDay) {
				// Make related container visible
				container.classList.remove('d-none');
			} else {
				// Hide all other containers
				container.classList.add('d-none');
			}
		})
	}
}

export {
	initProductionAuditionChooseAuditionIndex
}
